// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var React_Basic = require("../React.Basic/index.js");
var datepicker$prime = React_Basic.element($foreign["_datepicker"]);
module.exports = {
    "datepicker'": datepicker$prime
};
